import { render, staticRenderFns } from "./modal_dynamic.vue?vue&type=template&id=4da15853&scoped=true&"
import script from "./modal_dynamic.vue?vue&type=script&lang=js&"
export * from "./modal_dynamic.vue?vue&type=script&lang=js&"
import style0 from "./modal_dynamic.vue?vue&type=style&index=0&id=4da15853&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da15853",
  null
  
)

export default component.exports